import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { FilterTabType } from '../../../imageFilters.model';
import { FilterHeader } from '../FilterHeader';
import { ImageFiltersFormProps } from '../ImageFiltersForm';

export const CorrectedHeader = observer((props: ImageFiltersFormProps): ReactElement => {
  const handleClear = (): void => {
    props.onSetCorrected([]);
  };

  const isSelected = props.activeFilterType === FilterTabType.Corrected;
  const count = props.imageFilters.corrected.length;

  return (
    <FilterHeader
      filterType={FilterTabType.Corrected}
      isSelected={isSelected}
      labelKey='corrected'
      count={count}
      showClear={count > 0}
      onClear={handleClear}
      onSelect={props.onFilterTabSelect}
    />
  );
});
